import { defineComponent } from 'nest/platform/models';
import { getPortalId } from '../../common/utils';
import { ACADEMY_VIDEO_HOST_COMPONENT, NC_PLATFORM_NAME } from '../constants';
import { Z_INDEX_NAV_COMPONENT_DEFAULT } from '../../constants/z_index';
import { getAcademyQueryParams } from './internal/get-query-params';
import { ACADEMY_PIP_SESSION_KEY } from './academy-constants';
function hasVideoIdInSessionStorage() {
  try {
    const rawStoredVideoState = sessionStorage.getItem(ACADEMY_PIP_SESSION_KEY);
    const parsedRawStoredVideoState = JSON.parse(rawStoredVideoState || '{}');
    return Boolean(parsedRawStoredVideoState.videoId && !Number.isNaN(Number(parsedRawStoredVideoState.videoId)));
  } catch (e) {
    return false;
  }
}
export const academyVideoHostComponentDef = defineComponent(ACADEMY_VIDEO_HOST_COMPONENT, {
  name: ACADEMY_VIDEO_HOST_COMPONENT,
  platformName: NC_PLATFORM_NAME,
  path: `/academy-navigation-components/${getPortalId()}/academy-video-host`,
  queryParams: getAcademyQueryParams(),
  capabilities: [],
  scrolling: false,
  initiallyOpen: true,
  deferLoading: !hasVideoIdInSessionStorage(),
  iframeProps: {
    id: 'academy-video-host-iframe',
    ['data-test-id']: 'academy-video-host-iframe',
    title: 'academy-video-host-iframe',
    style: {
      position: 'fixed',
      zIndex: Z_INDEX_NAV_COMPONENT_DEFAULT
    }
  }
});